"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReturnsByScanCenter = getReturnsByScanCenter;
const center_1 = require("../center");
const constants_1 = require("../constants");
const format_date_1 = require("./format-date");
const parse_address_lines_1 = require("./parse-address-lines");
const replace_carriage_return_1 = require("./replace-carriage-return");
function getReturnsByScanCenter(returns, ScanCenter) {
    const i18n = constants_1.I18N_RETURNS_HEADINGS;
    const returnsByScanCenter = [];
    for (const item of returns) {
        const documents = item.documents || [];
        const scanIds = [];
        for (const document of documents) {
            const scanId = document.metadata?.scanId;
            if (scanId && document.scanCenter === ScanCenter) {
                scanIds.push(scanId);
            }
        }
        const documentIds = scanIds.join(',');
        if (!documentIds) {
            continue;
        }
        const { customer, requesterUser } = item;
        const address = item.address || constants_1.defaultAddress;
        const names = (0, parse_address_lines_1.parseAddressLines)(address.lines);
        const details = (0, center_1.getScanCenterDetails)({
            accountRegion: address.countryCode === 'DE'
                ? center_1.ScanCenterAccountRegion.DE
                : center_1.ScanCenterAccountRegion.INTERNATIONAL,
            publicId: customer.encodedPublicId,
            scanCenter: ScanCenter,
        });
        returnsByScanCenter.push({
            [i18n.recipientPublicID]: customer.encodedPublicId,
            [i18n.recipientName1]: (0, replace_carriage_return_1.replaceCarriageReturn)(names.name),
            [i18n.recipientNameAndPostBox]: (0, replace_carriage_return_1.replaceCarriageReturn)(names.additionalInfo),
            [i18n.recipientStreetAndHouseNumber]: (0, replace_carriage_return_1.replaceCarriageReturn)(address.streetAddress),
            [i18n.recipientPostCode]: (0, replace_carriage_return_1.replaceCarriageReturn)(address.zip),
            [i18n.recipientCity]: (0, replace_carriage_return_1.replaceCarriageReturn)(address.city),
            [i18n.recipientCountry]: address.countryCode,
            [i18n.recipientEmail]: requesterUser.email,
            [i18n.recipientPhone]: '+49 30 200042025',
            [i18n.recipientReference]: customer.encodedPublicId,
            [i18n.senderReference]: item.id,
            [i18n.senderName1]: details.pickingListSenderName,
            [i18n.senderStreetAndHouseNumber]: details.streetAndHouseNumber,
            [i18n.senderPostCode]: details.postCode,
            [i18n.senderCity]: details.city,
            [i18n.senderCountry]: 'DE',
            [i18n.packageWeight]: 1,
            [i18n.productAndServiceIdentification]: 'V01PAK',
            [i18n.accountNumber]: details.accountNumber,
            [i18n.returnType]: item.finishedBy === 'user' ? 'Sofortsendung' : 'Sammelsendung',
            [i18n.requestedAt]: (0, format_date_1.formatDate)(item.requestedAt),
            [i18n.documentIds]: documentIds,
        });
    }
    return returnsByScanCenter;
}
//# sourceMappingURL=get-returns-by-scan-center.js.map